import React from 'react';
import katharsis from '../assets/coverart/Katharsis.png';
import are from '../assets/coverart/ARE.jpg';
import fuehler from '../assets/coverart/fuehler.jpg';
import endlosschleifen from '../assets/coverart/Els.jpg';
import paradies from '../assets/coverart/paradies.jpg';
import maschinen from '../assets/coverart/Maschinen.jpg';
import vgmn from '../assets/coverart/Vergissmeinnicht.jpg';
import azu from '../assets/coverart/azu.jpg';
import bka from '../assets/coverart/bka.jpg';
import transformation from '../assets/coverart/Transformation.jpg';
import tiefseetauchen from '../assets/coverart/Tiefseetauchen.jpg';



import './Releases.css';

type Release = {
  img: string;
  alt: string;
  href: string;
  title: string;
};

/** Add new releases by dropping one more object in this list */
const releases: Release[] = [
        {
    img: tiefseetauchen,
    alt: "Tiefseetauchen cover art",
    href: "https://www.regentaenzer.com/tiefseetauchen",
    title: "Tiefseetauchen",
  },
        {
    img: transformation,
    alt: "Transformation cover art",
    href: "https://www.regentaenzer.com/transformation",
    title: "Transformation",
  },
      {
    img: bka,
    alt: "BKA cover art",
    href: "https://www.regentaenzer.com/bka",
    title: "Blickkontaktabbruch",
  },
    {
    img: azu,
    alt: "AZU cover art",
    href: "https://www.regentaenzer.com/azu",
    title: "Anleitung zur Unsichtbarkeit",
  },
   {
    img: vgmn,
    alt: "Vergissmeinnicht cover art",
    href: "https://www.regentaenzer.com/vergissmeinnicht",
    title: "Vergissmeinnicht",
  },
  {
    img: maschinen,
    alt: "Maschinen cover art",
    href: "https://www.regentaenzer.com/maschinen",
    title: "Maschinen",
  },
      {
    img: paradies,
    alt: "Paradies cover art",
    href: "https://www.regentaenzer.com/paradies",
    title: "Ein neues Paradies, oder: Die Zäune waren mal Bäume",
  },
    {
    img: endlosschleifen,
    alt: "Endlosschelifen cover art",
    href: "https://www.regentaenzer.com/endlosschleifen",
    title: "Endlosschleifen",
  },
   {
    img: fuehler,
    alt: "Fühler cover art",
    href: "https://www.regentaenzer.com/fuehler",
    title: "Fühler",
  },
  {
    img: are,
    alt: "ARE cover art",
    href: "https://www.regentaenzer.com/abwaertsradeleuphorie",
    title: "Abwärtsradeleuphorie",
  },
  {
    img: katharsis,
    alt: "Katharsis cover art",
    href: "https://www.regentaenzer.com/katharsis",
    title: "Katharsis",
  },
  // { img, alt, href, title }  ← just add more objects here
];

function Releases() {
  return (
    <div>
      <h3>MondWild</h3>
    
    <div className="cover-gallery">
      
      {releases.map(({ img, alt, href, title }) => (
        <div className="cover-card" key={title}>
          <div className="cover-art">
            <img src={img} alt={alt} />
          </div>

          <a href={href} target="_blank" rel="noopener noreferrer">
            <p>{title}</p>
          </a>
        </div>
      ))}
      </div>
    </div>
  );
}

export default Releases;